import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserAlt, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { AiOutlineSwapRight } from 'react-icons/ai';
import logo from '../assets/claricelogo.png';
import Toast from './Common/Toast';
import { API_BASE_URL } from '../apiConfig';
import '../Styles/login.css';

const CreateAccountForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: ''
  });
  const [notification, setNotification] = useState({ type: '', message: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: '', message: '' }), 5000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/account-requests/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        showNotification('success', data.message || 'Account request submitted successfully!');
        // Clear form
        setFormData({
          name: '',
          email: '',
          phoneNumber: ''
        });
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        showNotification('error', data.message || 'Failed to submit request');
      }
    } catch (error) {
      console.error('Error submitting account request:', error);
      showNotification('error', 'An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="loginPage flex">
      <Toast 
        type={notification.type} 
        message={notification.message} 
        onClose={() => setNotification({ type: '', message: '' })} 
      />
      <div className="container flex">
        <div className="formDiv flex">
          <div className="headerDiv">
            <img src={logo} alt="logo" />
            <h3>Create Account Request</h3>
          </div>

          <form onSubmit={handleSubmit} className="form grid">
            <div className="inputDiv">
              <label htmlFor="name">Full Name</label>
              <div className="input flex">
                <FaUserAlt className="icon" />
                <input 
                  type="text" 
                  id="name" 
                  name="name"
                  placeholder="Enter your full name" 
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="inputDiv">
              <label htmlFor="email">Email Address</label>
              <div className="input flex">
                <FaEnvelope className="icon" />
                <input 
                  type="email" 
                  id="email" 
                  name="email"
                  placeholder="Enter your email" 
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="inputDiv">
              <label htmlFor="phoneNumber">Phone Number</label>
              <div className="input flex">
                <FaPhoneAlt className="icon" />
                <input 
                  type="tel" 
                  id="phoneNumber" 
                  name="phoneNumber"
                  placeholder="Enter your phone number" 
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn" disabled={isLoading}>
              <span>{isLoading ? "Submitting..." : "Submit Request"}</span>
              {!isLoading && <AiOutlineSwapRight className="icon" />}
            </button>

            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <button 
                type="button" 
                onClick={() => navigate('/')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'var(--primarycolor)',
                  cursor: 'pointer',
                  fontSize: '14px',
                  textDecoration: 'underline'
                }}
              >
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateAccountForm;

